var Firerest = require('firerest');

const api = Firerest.create({
  api: spat.config.api.endpoint,
  cacheKey: '_token',
  tokenKey: 'Token',
  debug: spat.config.env !== 'production',
});

api.constant = Firerest.create({
  api: spat.config.constants_api.endpoint,
  debug: spat.config.env !== 'production',
});

// api.on('prefetch', async (ref) => {
//   var user = firebase.auth().currentUser;
//   if (user) {
//     var token = await user.getIdToken();
//     ref.headers({
//       Authorization: `Bearer ${token}`,
//     });
//   }
// });

export default api;
